import { useTheme } from "../ThemeProvider/ThemeContext.mjs";
const useThemeName = () => useTheme().name;
export {
  useThemeName
};
